import { Form } from 'react-bootstrap'
import { InputText } from '../../../../../../components/Inputs'
import { InputSelect } from '../../../../../../components/Inputs/InputSelect'
import { getSelectByKeys } from '../../../../../../helpers/helpers'
import { useLang } from '../../../../../../language'
import { EstadosAlquilerServices } from '../../../../../../services/statics.service'

export const FilterFormHead = ({ formValuesSearch, handleInputChangeSearch, showFilter, fetchParamsMultipleData }: any) => {

    const Lang = useLang()

    const staticEstadosAlquiler: any = EstadosAlquilerServices.GET()

    return (
        <>
            <Form.Group className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-3">
                <InputText
                    label={Lang('NUMERO_DE_PEDIDO') + ':'}
                    name='numeropedido'
                    value={formValuesSearch.numeropedido}
                    size='sm'
                    onChange={handleInputChangeSearch}
                />
            </Form.Group>

            <Form.Group className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                <InputText
                    label={Lang('PERSONA')}
                    name='nombreyapellidos'
                    value={formValuesSearch.nombreyapellidos}
                    size='sm'
                    onChange={handleInputChangeSearch}
                />
            </Form.Group>

            <Form.Group className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
                <InputSelect
                    label={Lang('ESTADO') + ':'}
                    name='estado'
                    value={formValuesSearch.estado}
                    onChange={handleInputChangeSearch}
                    size='sm'
                    values={getSelectByKeys(staticEstadosAlquiler)}
                />
            </Form.Group>
        </>
    )
}
